import React from 'react'
import { Flex, Box, Divider } from 'rebass'
import styled from 'styled-components'
import Container from '../../elements/Container'
import Title from '../../elements/Text/Title'
import Para from '../../elements/Text/Para'
import { colors, fontSizes } from '../../theme'
import {Fade, Flip} from 'react-reveal';

const TextSeparator = styled(Divider)`
  width: 30px;
  height: 5px;
  background-color: ${colors.secondary};
  border-bottom: none;
  border-radius: 15px;
  margin-bottom: 2rem;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
`

const Values = props => (
  <Container id="values" bg={colors.primary}>
    <Flex flexDirection={["column",,,"row"]}>
      <Box w={[1,,,1/2]} px={[3,,,4]} mx={[0,,,3]} py={[4,,,4]} style={{border: '1px solid #fdfdfd',  borderRadius: '10px'}}>
      <Flip left duration={1000}>
      <Title color={colors.white}>
          Our Values
        </Title>
        </Flip>
        <TextSeparator />
        <Fade bottom duration={1000}>
        <Para fontSize={fontSizes[3]+'px'}>
          We strive for excellence and follow the best industry practices and high
          quality standards in client delivery and service. We adhere strictly to client
          confidentiality standards. We are committed to integrity and fairness in our
          approach including all interaction and dealings with clients
        </Para>
        </Fade>
      </Box>
      <Box w={[1,,,1/2]} px={[3,,,4]} mx={[0,,,3]} py={[4,,,4]} mt={[4,,,0]} style={{border: '1px solid #fdfdfd', borderRadius: '10px'}}>
      <Flip left duration={1000}>
      <Title color={colors.white}>
          Our Approach
        </Title>
        </Flip>
        <TextSeparator />
        <Fade bottom duration={1000}>
        <Para fontSize={fontSizes[3]+'px'}>
          We help our clients solve complex business problems and use our
          experience, talent and business understanding to create value for them.
          We focus on relationships with our clients. We invest time in understanding
           our clients, their businesses and timely delivery.
         
        </Para>
        </Fade>
      </Box>
    </Flex>
  </Container>
)

export default Values


// WEBPACK FOOTER //
// ./src/components/home/Values.js